import { render, staticRenderFns } from "./recentDetail.vue?vue&type=template&id=2a168cb8&scoped=true&"
import script from "./recentDetail.vue?vue&type=script&lang=js&"
export * from "./recentDetail.vue?vue&type=script&lang=js&"
import style0 from "./recentDetail.vue?vue&type=style&index=0&id=2a168cb8&scoped=true&lang=scss&"
import style1 from "./recentDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a168cb8",
  null
  
)

export default component.exports